export const TOPICS_FILTER_PARAM_KEY = 'topics';
export const OFFICE_HOURS_FILTER_PARAM_KEY = 'hasOfficeHours';
